import { Component, OnInit } from '@angular/core';
import { ToasterService } from 'src/app/_services/toaster.service';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { AssessmentStatus, ImpairmentCategory, TwoDimensionalAssessmentResult, TwoDimensionalAiAssessmentViewModel, TwoDimensionalAiAssessmentViewModelRead, SpeedUnit, DistanceUnit, WeightUOM } from 'src/app/_models/generatedModels';
import { AssessmentService } from 'src/app/_services/generatedServices';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { getParamFromRoute } from 'src/app/_helpers/extensions.module';
import { BreadcrumbsService } from 'src/app/_services/breadcrumbs.service';
import { FormCanDeactivate } from 'src/app/_guards/canDeactivate.guard';
import { PublicVideoPopupExampleComponent } from './public-video-popup-example.component';
import { TermsAndConditionsDialogComponent } from '../../_components/terms-and-conditions-dialog/terms-and-conditions-dialog.component';

@Component({
  selector: 'public-bxl-add-2d-ai-assessment',
  templateUrl: 'public-add-2d-ai-assessment.component.html',
  styleUrls: ['public-add-2d-ai-assessment.component.scss'],
})
export class PublicAdd2DAiAssessmentComponent extends FormCanDeactivate implements OnInit {
  initialized = false;
  finished = false;
  assessment: TwoDimensionalAiAssessmentViewModelRead;
  twoDAssessmentResult = TwoDimensionalAssessmentResult;
  distanceUnit = DistanceUnit;
  speedUnit = SpeedUnit;
  weightUnit = WeightUOM;
  assessmentStatus = AssessmentStatus;
  ImpairmentCategory = ImpairmentCategory;
  public formGroup: FormGroup;
  submitComplete: Promise<{}> | undefined;
  leftOption: any = { label: 'Needs Attention', value: 'NeedsAttention' };
  rightOption: any = { label: 'Satisfactory', value: 'Satisfactory' };

  constructor(private route: ActivatedRoute, private router: Router, private toastr: ToasterService, private modalService: NgbModal, private assessmentService: AssessmentService, private fb: FormBuilder, private breadcrumbs: BreadcrumbsService) {
    super();
  }

  ngOnInit(): void
  {
    this.setupForm();
  }

  setupForm(): any
  {
    let videos = this.fb.array([this.initializeVideo(), this.initializeVideo()], [this.twoVideosValidator()]);

    this.formGroup = this.fb.group({
      publicUserEmail: [this.assessment?.publicUserEmail, [Validators.required, Validators.email]],
      assessmentNotes: [this.assessment?.assessmentNotes],
      videos: videos,
      runnerWeight: [null, [Validators.required, Validators.min(40)]],
      weightUnit: [1],
      runnerHeight: [null, [Validators.required, Validators.min(40)]],
      heightUnit: [2],
      allowUse: [false, [Validators.requiredTrue]],
      acceptTerm: [false, [Validators.requiredTrue]],
      isInjured: [false],
    });

    this.formGroup.markFormDirtyOnValueChange().subscribe();
    this.initialized = true;
  }

  initializeVideo(): FormGroup {
    return this.fb.group({
      id: [0],
      videoId: [null],
      description: [null]
    });
  }

  onDecimalInput(event: Event)
  {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9.]/g, '');
  }

  onSave()
  {
    if (!this.formGroup.valid) {
      this.formGroup.markAllControlsDirty();
      this.toastr.error('Please fill out all required fields', 'Error');
      return;
    }

    this.formGroup.markAsPristine();
    this.submitComplete = new Promise((resetButton:any, reject) => {
      const formData: TwoDimensionalAiAssessmentViewModel = Object.assign({}, this.formGroup.value, this.formGroup.value);
      formData.videos = formData.videos.filter(x => x.videoId != null);
      this.save(formData, resetButton);
    });
  }

  save(formData: TwoDimensionalAiAssessmentViewModel, resetButton: () => any)
  {
    this.assessmentService.createPublicTwoDimensionalAiAssessment(formData).subscribe(
      (assessment) => {
        this.finished = true;
        resetButton();
      },
      (error) => resetButton()
    );
  }

  twoVideosValidator(): ValidatorFn
  {
    return (control: AbstractControl): ValidationErrors | null =>
    {
      const videos = control as FormArray;
      const isValid = videos.controls.every(video => video.get('videoId')?.value);
      return isValid ? null : { twoVideosRequired: true };
    };
  }

  showSideExampleVideo()
  {
    const modalRef = this.modalService.open(PublicVideoPopupExampleComponent, { size: 'lg', ariaLabelledBy: 'modal-basic-title' });
    modalRef.componentInstance.analysisName = 'Side view video example';
    modalRef.componentInstance.videoLink = "https://wv-cdn-00-00.wowza.com/ea8c6bfa-c593-4e7f-9cb5-63eeeb7b20ec/cmaf/5e7303cc-f13a-4478-b1d1-726f4c186349/playlist.m3u8";
    modalRef.componentInstance.description = '';
    modalRef.componentInstance.encoded = true;

    modalRef.result.then(
      (result) => { },
      (reason) => { }
    );
  }

  reloadPage()
  {
    window.location.href = window.location.href;
  }


  onAllowUseChange(event: any)
  {
    
  }

  onViewTerms()
  {
    const modalRef = this.modalService.open(TermsAndConditionsDialogComponent, { size: 'lg', windowClass: 'modal-xl-custom' });
    modalRef.result.then(
      (result) => { },
      (reason) => { }
    );
  }

  showBackExampleVideo()
  {
    const modalRef = this.modalService.open(PublicVideoPopupExampleComponent, { size: 'lg', ariaLabelledBy: 'modal-basic-title' });
    modalRef.componentInstance.analysisName = 'Back view video example';
    modalRef.componentInstance.videoLink = "https://wv-cdn-00-00.wowza.com/ea8c6bfa-c593-4e7f-9cb5-63eeeb7b20ec/cmaf/57b56fe7-7ea0-403c-81c7-2b85db771aaa/playlist.m3u8";
    modalRef.componentInstance.encoded = true;
    modalRef.componentInstance.description = '';

    modalRef.result.then(
      (result) => { },
      (reason) => { }
    );
  }
}
